/* eslint-disable ember/no-controller-access-in-routes, warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';
import { isEmpty } from '@ember/utils';
import ProgressionType from '@linc-technologies/linced-common/enums/progression-type';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class MilestonesRoute extends Route {
  // Services
  @service
  store;

  model() {
    return hash({
      milestones: this.store.query('milestones/milestone', {
        progressionType: ProgressionType.PROGRESSION,
      }),
      milestoneSets: this.store.query('milestones/milestone-set', {
        include: 'milestones',
      }),
      levels: this.store.findAll('milestones/level'),
      expectations: this.store.findAll('milestones/expectation'),
      subjects: this.store
        .query('goals/subject', { trackable: true })
        .then((subjects) =>
          subjects
            .slice()
            .sort((a, b) => (a.label || '').localeCompare(b.label || '')),
        ),
      allSubjects: this.store
        .findAll('goals/subject')
        .then((subjects) =>
          subjects
            .slice()
            .sort((a, b) => (a.label || '').localeCompare(b.label || '')),
        ),
      goalCategories: this.store.findAll('goals/category'),
    });
  }

  afterModel(model) {
    // Sort Milestone Sets alphabetically.
    model.milestoneSets = model.milestoneSets
      .slice()
      .sort((a, b) => (a.label || '').localeCompare(b.label || ''));

    // Add "default milestones" virtual option if there are any default
    // Milestones - or if there are no Milestone Sets.
    if (!isEmpty(model.milestones) || isEmpty(model.milestoneSets)) {
      let sets = model.milestoneSets.slice();
      sets.unshift({ label: 'Default Milestones', isDefault: true });
      model.milestoneSets = sets;
    }

    // Select the first option (whether default or a Set) as the default.
    this.controllerFor('milestones').set(
      'selectedMilestoneSet',
      model.milestoneSets[0],
    );

    return super.afterModel(...arguments);
  }
}
